import {
    formatUnits,
    getCompactDollars,
} from "../../../agent-production/helpers/dataFormatters";
import { terms as mdt } from "..";
import { cardFields } from ".";

export const cardSettings = {
    gridClass: 'grid-3',
    cards: [
        {
            formatter: getCompactDollars,
            keyField: cardFields.soldVolume,
            title: mdt.soldVolumeParens,
        },
        {
            formatter: getCompactDollars,
            keyField: cardFields.ucVolume,
            title: mdt.ucVolumeParens,
        },
        {
            formatter: getCompactDollars,
            keyField: cardFields.forSaleVolume,
            title: mdt.forSaleVolumeParens,
        },
        {
            formatter: formatUnits,
            keyField: cardFields.soldUnits,
            title: mdt.soldUnitsParens,
        },
        {
            formatter: formatUnits,
            keyField: cardFields.ucUnits,
            title: mdt.ucUnitsParens,
        },
        {
            formatter: formatUnits,
            keyField: cardFields.forSaleUnits,
            title: mdt.forSaleUnitsParens,
        },
    ],
};
